import { ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
    selector: 'op-pricing-content',
    templateUrl: './pricing-content.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PricingContentComponent {
}